/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Dashboard_Sales_Awaiting_ConfirmInputs */

const vi_dashboard_sales_awaiting_confirm = /** @type {(inputs: Dashboard_Sales_Awaiting_ConfirmInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Đơn chờ xác nhận`)
};

/**

* @param {Dashboard_Sales_Awaiting_ConfirmInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const dashboard_sales_awaiting_confirm = /** @type {((inputs?: Dashboard_Sales_Awaiting_ConfirmInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Dashboard_Sales_Awaiting_ConfirmInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_dashboard_sales_awaiting_confirm(inputs)
});